import { useEffect, useState } from 'react';

/*
|--------------------------------------------------------------------------
| Util Methods
|--------------------------------------------------------------------------
*/

function getDocumentHeight(): number {
    const body = document.body;
    const html = document.documentElement;

    return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );
}

function isScrolledToBottomOfPage(): boolean {
    return getDocumentHeight() - (window.innerHeight + window.pageYOffset) < 10;
}

/*
|--------------------------------------------------------------------------
| Hook
|--------------------------------------------------------------------------
*/

interface IUseScrollPositionReturnData {
    isScrollNearBottom: boolean;
}

export default (): IUseScrollPositionReturnData => {
    const [isScrollNearBottom, setIsScrollNearBottom] = useState(
        isScrolledToBottomOfPage()
    );
    const [scrollPositionY, setScrollPositionY] = useState(window.pageYOffset);

    const scrollHandler = () => {
        setScrollPositionY(window.pageYOffset);
    };
    const updateScrollPosition = () => {
        const isNearBottom = isScrolledToBottomOfPage();
        if (isNearBottom && !isScrollNearBottom) {
            setIsScrollNearBottom(true);
        }
        if (!isNearBottom && isScrollNearBottom) {
            setIsScrollNearBottom(false);
        }
    };

    window.addEventListener('scroll', scrollHandler);

    setInterval(updateScrollPosition, 3500);

    useEffect(() => {
        updateScrollPosition();
        return window.removeEventListener('scroll', scrollHandler);
    }, [scrollPositionY]);

    return {
        isScrollNearBottom,
    };
};
